













import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { GetRequest } from '@/store/requeststate';
import { Parser } from 'xml2js';

@Component({})
export default class Rss extends Vue {
    @Action('get', {namespace: 'requestState'})
    public get!: (req: GetRequest) => Promise<any>;

    @Prop()
    private title!: string;

    @Prop()
    private url!: string;

    @Prop()
    private rssUrl!: string;

    private newsList: any[] = [];

    private async mounted() {
        const res = await this.get({path: 'api/rss/proxy', params: {url: this.rssUrl}});
        let content = res['content'];
        const firstIndex = content.indexOf('<');
        if (firstIndex > 0) {
            content = content.slice(firstIndex);
        }

        const parser = new Parser();
        const it = this;
        parser.parseString(content, function(err: any, result: any) {
            let groups = [];
            let root: any = {};
            if (!result) {
                return;
            }
            if (result.hasOwnProperty('rdf:RDF')) {
                root = result['rdf:RDF'];
            } else if (result.hasOwnProperty('rss')) {
                root = result['rss'];
            } else {
                return;
            }
            let items = [];
            if (root.hasOwnProperty('item')) {
                items = root['item'];
            } else if (root.hasOwnProperty('channel') && root['channel'][0].hasOwnProperty('item')) {
                items = root['channel'][0]['item'];
            }else {
                return;
            }
            for (let itemIndex in items) {
                if (groups.length >= 10) {
                    break;
                }
                groups.push({
                    title: items[itemIndex]['title'][0],
                    url: items[itemIndex]['link'][0],
                });
            }
            it.newsList = groups;
        });
    }
}
